/* Inkopious (Oct 2026) menu tweaks.
   1. Mobile: tapping the name of a top-level item that has a mega menu
      (Shop, Styles) opens its dropdown instead of going to the page.
   2. Desktop: for mega menus set to "dropdown only", clicking the top link
      (e.g. Shop) keeps the dropdown open instead of loading a page. */
(function () {
  if (window.inkMobileTap) return;
  window.inkMobileTap = true;

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#mobile_menu > li.sublink > a.parent-link--true');
    if (!a) return;
    var li = a.parentElement;
    if (!li.querySelector(':scope > ul[data-meganav-target-container]')) return;
    var arrow = a.querySelector('.icon-down-arrow');
    if (!arrow || arrow.contains(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    arrow.click();
  }, true);

  window.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('summary[data-nav-desktop-link]');
    if (!s) return;
    var d = s.parentElement;
    if (!d || !d.querySelector('[data-inkmm-nolink]')) return;
    /* Stop the theme's "go to the link" handler and the native toggle,
       so the dropdown (opened on hover or focus) simply stays open. */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!d.open) d.open = true;
  }, true);
})();